import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next"

interface DateTimeLocalProps {
  dateTimeUtc: string
}

export default function DateTimeLocal({ dateTimeUtc: dateTime }: DateTimeLocalProps) {
  const { i18n } = useTranslation();
  const [formatted, setFormatted] = useState("");

  useEffect(() => {
    if (!dateTime) return;

    const date = new Date(dateTime);

    const formattedDate = new Intl.DateTimeFormat(i18n.language, {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    }).format(date);

    setFormatted(formattedDate);
  }, [dateTime, i18n.language]);

  return <span>{formatted}</span>;
}
